<template>
  <div class="container-fluid p-0 m-0">
    <ViewImage ref="viewImage" />
    <p class="h4 font-italic welcome-text"><b>{{ $t('gallery') }}</b></p>
    <div v-for="gallery_category in gallery_categories" class="container-fluid mt-5 mb-5">
      <p class="text-left text-warning font-bold h5 border-bottom border-warning">{{ gallery_category.fields['name_'+getCurrentLanguage()] }}</p>
      <p class="text-left welcome-text">{{ gallery_category.fields['description_'+getCurrentLanguage()] }}</p>
      <div class="row justify-content-center">
        <div v-for="galleryItem in gallery" v-if="galleryItem.fields.category === gallery_category.pk"  @click="handleShowImage" class="col-sm-12 col-md-6 col-lg-3 mt-3">
          <img width="300" class="img-thumbnail mx-auto d-block" alt="gallery image" :src="`${$request}media/${galleryItem.fields.image}`">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewImage from "./ViewImage";

export default {
  name: "GalleryPage",
  components: {
    ViewImage
  },
  data(){
    return {
      gallery_categories: this.$gallery_categories,
      gallery: this.$gallery
    }
  },
  methods: {
    getCurrentLanguage(){
      return this.$i18n.locale
    },
    handleShowImage(el) {
      this.$refs.viewImage.showModal(el.path[0].src);
    },
  }
}
</script>

<style scoped>
.welcome-text{
  color: #392A20;
}
</style>



// WEBPACK FOOTER //
// src/components/GalleryPage.vue